module.exports = __webpack_public_path__ + "img/volunteer2.290a35ea.jpg";